module.exports = __webpack_public_path__ + "assets/images/age_r.abfb6dfc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/age_r.png
// module id = 673
// module chunks = 1